<template>
    <main-layout>
        <template #header>
            <main-header :title="'시스템 유저 권한 설정'" backable></main-header>
        </template>

        <template #body>
            <h2 class="text-left mb-3">{{ serverData.displayName }}</h2>

            <template v-if="!loading">
                <system-user-permission-tree-view
                        :items="items"
                        @click:bind="onBindClicked"
                        @click:unbind="onUnbindClicked"
                >
                </system-user-permission-tree-view>
            </template>
            <template v-else>
                <div>
                    <v-progress-circular indeterminate size="48" :color="'primary'"
                    ></v-progress-circular>
                    <div class="mt-3">로드중...</div>
                </div>
            </template>
        </template>
    </main-layout>
</template>

<script>
    import MainLayout from "@/components/common/layout/MainLayout";
    import MainHeader from "@/components/common/layout/MainHeader";
    import {PATH} from "@/constants";
    import {PermissionTree} from "@/assets/plugins/mps-common/user/permission-manager";
    import SystemUserPermissionTreeView from "@/views/sysuser/SystemUserPermissionTreeView";

    export default {
        name: "SystemUserPermissionManage",
        components: {SystemUserPermissionTreeView, MainHeader, MainLayout},
        props: {
            adminUserId: {
                type: String,
                default: undefined,
            }
        },
        data() {
            return {
                loading: false,
                permissionTree: undefined,
                serverData: {},
            };
        },
        computed: {
            items() {
                if (!this.permissionTree) return [];
                return this.permissionTree.items;
            },
        },
        created() {
            this.loadDetail();
            this.load();
        },
        methods: {
            async loadDetail() {
                this.serverData = await this.$request(PATH.ADMIN_USER.GET)
                    .setObject({adminUserId: this.adminUserId})
                    .enqueue();
            },

            async load() {
                this.loading = true;
                await this.loadPermissions();
                const response = await this.$request(PATH.ADMIN_USER_PERMISSION.LIST)
                    .setObject({adminUserId: this.adminUserId})
                    .enqueue();

                this.permissionTree.nodes.forEach(node => {
                    if (!!response.data.find(item => node.id === item.id)) { // 그룹 아이템에 속한 노드라면
                        node.binded = true;
                    } else {
                        node.binded = false;
                    }
                });
                this.loading = false;
            },

            async loadPermissions() {
                const response = await this.$request(PATH.SYSTEM_PERMISSION.ALL_PERMISSION_BY_SYSTEM)
                    .post()
                    .enqueue();
                this.permissionTree = new PermissionTree(response.data);
            },

            /**
             * 권한 그룹 적용을 클릭하였습니다.
             */
            onBindClicked(node) {
                this.$confirm(this.serverData.displayName + " 유저에 " + node.canonicalName + " 권한을 추가하시겠습니까? !!상위의 노드들도 모두 해당 유저에게 추가됩니다.")
                    .then(() => this.requestBind({
                        permissionId: node.id,
                        adminUserId: this.adminUserId,
                    }));
            },

            async requestBind(requestBody) {
                await this.$requestWithOverlay(PATH.ADMIN_USER_PERMISSION.BIND)
                    .setObject(requestBody)
                    .enqueue();
                await this.load();
            },

            /**
             * 권한 그룹 적용해제를 클릭하였습니다.
             */
            onUnbindClicked(node) {
                this.$confirm(this.serverData.displayName + " 유저의 " + node.canonicalName + " 권한을 삭제하시겠습니까? 자식 노드의 권한들도 모두 해당 유저에서 삭제됩니다.")
                    .then(() => this.requestUnbind({
                        permissionId: node.id,
                        adminUserId: this.adminUserId,
                    }));
            },

            async requestUnbind(requestBody) {
                await this.$requestWithOverlay(PATH.ADMIN_USER_PERMISSION.UNBIND)
                    .setObject(requestBody)
                    .enqueue();
                await this.load();
            },
        },
    }
</script>

<style scoped>

</style>